import { LitElement, html, TemplateResult } from "lit";
import { customElement, state } from "lit/decorators.js";
import { SlhCoreCollapsibleArea } from "@slhuicore/collapsible-area";
import { IconDefaultType as IconType } from "@slhuiicon/icon";
import { style } from "./assets/collapsible-area.generated-style";

/**
 * Allows users to group a set of data or use it as a container with the ability to collapse content.
 * @CustomElement slh-collapsible-area
 *
 * @cssprop --slh-default-font-family - Font family.
 * @cssprop --slh-base-l-font-size - Collapsible title font size.
 * @cssprop --slh-base-bold-font-weight - Collapsible title font weight.
 * @cssprop --slh-base-xxs-line-height - Collapsible title line height.
 * @cssprop --slh-color-neutral-shade-00 - Mobile collapsible wrapper background.
 * @cssprop --slh-color-neutral-shade-40 - Collapsible title border bottom.
 * @cssprop --slh-color-neutral - Collapsible title color.
 * @cssprop --slh-base-xs-font-size - Collapsible title size for devices with a width of less than 560px.
 *
 * @slot title - Collapsible area title.
 * @slot default - Collapsible area content.
 */
@customElement("slh-collapsible-area")
export default class SlhCollapsibleArea extends SlhCoreCollapsibleArea(
  LitElement
) {
  static styles = style;

  @state()
  iconType: IconType = IconType.ICO_ARROW_OPEN_DOWN;

  private setIcon() {
    if (this.expanded) {
      this.iconType = IconType.ICO_ARROW_OPEN_UP;
    } else {
      this.iconType = IconType.ICO_ARROW_OPEN_DOWN;
    }
  }

  /**
   * @returns {TemplateResult} render html template
   */
  renderIcon(): TemplateResult {
    return html`<slh-icon type="${this.iconType}"></slh-icon>`;
  }
}
